document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const searchButtons = document.querySelectorAll('[data-search-toggle]');
  const closeButtons = document.querySelectorAll('[data-drawer-close]');

  const setMenu = (open) => {
    if (!menu || !menuToggle) return;
    menu.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open);
  };
  const setSearch = (open) => {
    if (!searchDrawer || !backdrop) return;
    searchDrawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    if (open) {
      const input = searchDrawer.querySelector('input');
      if (input) setTimeout(() => input.focus(), 150);
    }
  };

  menuToggle?.addEventListener('click', () => setMenu(!menu.classList.contains('is-open')));
  searchButtons.forEach((button) => button.addEventListener('click', () => setSearch(true)));
  closeButtons.forEach((button) => button.addEventListener('click', () => { setSearch(false); setMenu(false); }));
  backdrop?.addEventListener('click', () => setSearch(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { setSearch(false); setMenu(false); }
  });
  window.addEventListener('scroll', () => header?.classList.toggle('is-scrolled', window.scrollY > 40), { passive: true });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(0, Number(input.value || 1) + Number(button.dataset.change || 0));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-add-to-cart]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const original = button.innerHTML;
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Cart request failed');
        button.innerHTML = 'Added';
        setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1800);
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
      } catch (error) {
        form.submit();
      }
    });
  });
});